import React from "react";
import { BASE_LOGIN_REDIRECT_URL } from "../../constants/api.constants";

export default function NotificationImage({ imageUrl }) {
  return (
    <img
      style={{ width: "853px", height: "480px" }}
      alt={imageUrl}
      src={BASE_LOGIN_REDIRECT_URL.replace("/lwc", "") + "/" + imageUrl}
    ></img>
  );
}
